import React, { useEffect, useState } from 'react'
import '../i18next.react'
import { useTranslation } from 'react-i18next'
import ReactModal from 'react-modal'
import i18next from 'i18next'

const LanguageSelectorModal = ({ isOpen, $scope }) => {
  const languages = [
    { key: 'english', value: 'en' },
    { key: 'french', value: 'fr' },
    { key: 'italian', value: 'it' },
    { key: 'spanish', value: 'es' }]

  const { t } = useTranslation('language')
  const [language, setLanguage] = useState(i18next.language)
  const [modalIsOpen, setIsOpen] = useState(isOpen)

  const switchLanguage = () => {
    i18next.changeLanguage(language)
      .then(r => window.location.reload())
  }

  const closeModal = () => {
    setIsOpen(false)
    $scope.$parent.model.showLanguageDialog = false
    $scope.$apply()
  }

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '30%'
    },
    overlay: {
      backgroundColor: 'rgb(150,150,150,0.5)'
    }
  }
  const closeButtonStyle = {
    backgroundColor: 'rgb(255,255,255,1)',
    marginLeft: '99%',
    marginTop: '-2%',
    borderColor: 'rgb(255,255,255,1)',
    fontWeight: 'bold',
    textDecoration: 'none',
    visited: 'black',
    hover: 'black',
    active: { textDecoration: 'none', color: 'black' },
    color: 'black'
  }

  ReactModal.setAppElement('#modal')
  useEffect(() => { setIsOpen(isOpen) }, [isOpen])

  return (
    <ReactModal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
    >
      <a href='' onClick={closeModal} style={closeButtonStyle}>X</a>
      <div className='container'>
        <p className='page-heading'>{t('lang-select')}</p><br />
        {languages.map(f => (
          <p key={f.key}>
            <input
              type='radio'
              value={f.value}
              checked={language === f.value}
              onChange={e => setLanguage(e.currentTarget.value)}
            />
            &nbsp;{t(f.key)}
          </p>
        ))}
        <br /><button className='button' onClick={switchLanguage}>{t('confirm')}</button><br />
      </div>
    </ReactModal>
  )
}

export default LanguageSelectorModal
